import React from 'react';
import { useNavigate } from 'react-router-dom';
import HandbookSidebar from './HandbookSidebar';
import HandbookHero from './HandbookHero';
import HandbookContent from './HandbookContent';
import '../HandbookStyles.scss';

interface HandbookData {
  theme: 'cnw' | 'krissco';
  title: string;
  hero: {
    eyebrow: string;
    title: string;
    description: string;
    chips: string[];
  };
  subStrip?: {
    label: string;
    items: Array<{ main: string; sub: string }>;
  };
  sections: any[];
}

interface LayoutProps {
  data: HandbookData;
}

const HandbookLayout: React.FC<LayoutProps> = ({ data }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = data.title;

    const sectionsNodes = document.querySelectorAll('.handbook-section');
    const navItemsNodes = document.querySelectorAll('.nav-item');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          navItemsNodes.forEach(item => item.classList.remove('active'));
          const id = entry.target.id;
          const activeLink = document.querySelector(`.nav-item[href='#${id}']`);
          if (activeLink) activeLink.classList.add('active');
        }
      });
    }, { threshold: 0.3 });

    sectionsNodes.forEach(s => observer.observe(s));

    return () => {
      sectionsNodes.forEach(s => observer.unobserve(s));
    };
  }, [data.title, data.sections]);

  const { theme, hero, subStrip, sections } = data;

  const handleNavigation = () => {
    navigate('/user-dashboard');
  }

  return (
    <div className='page-container bg-customBg handbook-layout-container'>
      <div className='full-width-container mt-5'>
        <div className='bg-white p-5 h-[calc(100vh-90px)] overflow-hidden flex flex-col'>
          <div className="flex justify-between flex-shrink-0 relative z-10">
            <div>
              <ul className='flex pb-5'>
                <li className='text-[#878787] text-[16px] cursor-pointer hover:text-pink-500' onClick={handleNavigation}>User Dashboard /</li>
                <li className='text-[16px] pl-1 text-[#ff4081] font-normal'>Employee Handbook</li>
              </ul>
            </div>
          </div>

          <div className={`handbook-wrapper theme-${theme} flex-grow`} style={{ border: '1px solid var(--border)', borderRadius: '12px' }}>
            <HandbookSidebar theme={theme} sections={sections} />

            <div className="handbook-main">
              <HandbookHero theme={theme} hero={hero} subStrip={subStrip} />
              <HandbookContent theme={theme} sections={sections} />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HandbookLayout;
